import { render } from "./gbjg.vue?vue&type=template&id=7f06aa4d&scoped=true&ts=true"
import script from "./gbjg.vue?vue&type=script&lang=ts"
export * from "./gbjg.vue?vue&type=script&lang=ts"

import "./gbjg.vue?vue&type=style&index=0&id=7f06aa4d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f06aa4d"]])

export default __exports__